import { GridOptions, ColDef } from 'ag-grid';
import { OperationItem } from 'types/operation-item';
import { Dictionary } from 'types/Dictionary';

export interface GridLayout {
  columns: ColDef[];
}

export enum GridLayoutType {
  none = '',
  usersComputer = 'usersComputerLayout',
  usersMobile = 'usersMobileLayout'
}

export const layoutsDefinitions: Dictionary<GridLayout> = {
  [GridLayoutType.usersComputer]: {
    columns: []
  },
  [GridLayoutType.usersMobile]: {
    columns: []
  }
};

export interface UserGridState {
  layouts: Dictionary<GridLayout>;
  rows: OperationItem[];
  selectedRow: string;
  enableFilter: boolean;
}

export interface State {
  options: GridOptions;
}

export const initialState: UserGridState = {
  layouts: layoutsDefinitions,
  rows: [],
  selectedRow: '',
  enableFilter: true
};


// WEBPACK FOOTER //
// ./src/components/user-grid/state.ts